<template lang="pug">
div
  label Type duration*
  .product-scheduling-options
    SchedulerSelector(
      title="Fixed duration",
      description="A fixed duration regardless of the number of participants."
      :selected="selectorIsSelected('fixedDuration')"
      size="small"
      :disabled="selectorIsDisabled('fixedDuration')"
      type="fixedDuration"
      @selected="p => $emit('selectSchedulingBehavior', p)"
      )
    // todo: if enableProductDurationPerParticipant is false, fixed duration does not need to be a button
    SchedulerSelector(
      v-if="enableProductDurationPerParticipant"
      title="Per participant",
      description="A variable duration depending on the number of participant(s)."
      :selected="selectorIsSelected('perParticipants')"
      size="small"
      :disabled="selectorIsDisabled('perParticipants')"
      type="perParticipants"
      @selected="p => $emit('selectSchedulingBehavior', p)"
      )
  hr
  .schedule-section
    BriqDurationInput(
      label="Duration"
      data-test-id="duration-input"
      :hideOptionalMarker="true"
      :useInputInIsoFormat="true"
      :hideClearButton="true"
      :excludeSeconds="true"
      :disabled="disabled"
      :error="customDurationError"
      :placeholder="durationPlaceholder"
      v-model="customDuration"
      )
  .schedule-section(v-if="enableProductDurationPerParticipant && schedulingBehavior === 'perParticipants'" data-test-id="per-participants-section")
    BriqInput(
      label="Per number of participants"
      type="number"
      step="1"
      :hideOptionalMarker="true"
      :disabled="disabled"
      :error="numberOfParticipantsPerDurationError"
      v-model.number="product.ProductDurationConfig.NumberOfParticipantsPerDuration"
      data-test-id="per-number-of-participants"
      @blur="vuelidate.product.ProductDurationConfig.NumberOfParticipantsPerDuration.$touch()"
      )
    BriqDurationInput(
      label="Starting duration"
      :disabled="disabled"
      help="A starting duration, to which the time per participant is added on top."
      v-model="product.ProductDurationConfig.StartDuration"
      :useInputInIsoFormat="true"
      :hideClearButton="true"
      :excludeSeconds="true"
      :error="startDurationError"
      @blur="vuelidate.product.StartDuration.$touch()"
      )
    BriqDurationInput(
      label="Minimum duration"
      :disabled="disabled"
      help="If the duration per participant results in less time than this, the duration is set to this."
      v-model="product.ProductDurationConfig.MinimumDuration"
      :useInputInIsoFormat="true"
      :hideClearButton="true"
      :excludeSeconds="true"
      )
    BriqDurationInput(
      label="Maximum duration"
      :disabled="disabled"
      help="If the duration per participant results in more time than this, the duration is set to this."
      v-model="product.ProductDurationConfig.MaximumDuration"
      :error="maximumDurationError"
      :useInputInIsoFormat="true"
      :hideClearButton="true"
      :excludeSeconds="true"
      @blur="vuelidate.product.MaximumDuration.$touch()"
      )
</template>

<script>
import BriqIsoDurationInput from '@v/components/BriqIsoDurationInput.vue'
import BriqDurationInput from '@v/components/BriqDurationInput.vue'
import SchedulerSelector from './SchedulerSelector.vue'
import { validatePaths } from '@/vue/util/propValidators.js'

export default {
  name: 'ProductSchedulingSequentialConfig',
  components: {
    BriqIsoDurationInput,
    BriqDurationInput,
    SchedulerSelector,
  },
  props: {
    enableProductDurationPerParticipant: Boolean,
    vuelidate: {
      type: Object,
      // validator: validatePaths([
      //   ['product', 'ModifiedDuration', '$error'],
      //   ['product', 'ModifiedDuration', '$touch'],
      //   ['product', 'DurationPerNrOfParticipants', '$error'],
      //   ['product', 'MaximumDuration', '$error'],
      // ]),
    },
    product: Object,
    resource: Object,
    selectorAvailability: Object,
    disabled: Boolean,
    isParallelProduct: Boolean,
    schedulingBehavior: String,
    isSequential: Boolean,
    maximumDurationError: String,
    startDurationError: String,
  },
  computed: {
    customDurationError() {
      if (!this.vuelidate.product?.ProductDurationConfig?.CustomDuration?.$error) return null
      return 'Duration is required and must not be zero'
    },
    numberOfParticipantsPerDurationError() {
      if (!this.vuelidate.product?.ProductDurationConfig?.NumberOfParticipantsPerDuration?.$error)
        return null
      return 'Per number of participants is required and must not be 0'
    },
    customDuration: {
      get: function() {
        return this.product.ProductDurationConfig.CustomDuration
      },
      set: function(newValue) {
        this.vuelidate.product.ProductDurationConfig.CustomDuration.$touch()
        this.product.ProductDurationConfig.CustomDuration = newValue
        this.product.ProductDurationConfig.UseResourceDuration = !newValue
      },
    },
    durationPlaceholder() {
      return this.resource?.DefaultTimeslotDuration &&
        this.resource?.ProductsAreDefaultScheduled === true
        ? this.resource?.DefaultTimeslotDuration
        : ''
    },
  },
  methods: {
    selectorIsDisabled(key) {
      return this.disabled || this.selectorAvailability?.[key] === false || this.isParallelProduct
    },
    selectorIsSelected(key) {
      if (key === this.schedulingBehavior) return true
      if (key === 'sequential' && this.isSequential) return true
      return false
    },
  },
  mounted() {
    this.product.ProductDurationConfig.UseResourceDuration = !this.product.ProductDurationConfig
      .CustomDuration
  },
}
</script>

<style scoped lang="stylus">
.product-scheduling-options
  display flex
  justify-content space-between
</style>
